import arsenal from './assets/club-shields/ARS.svg'
import astonVilla from './assets/club-shields/AVL.svg'
import bournemouth from './assets/club-shields/BOU.svg'
import brentford from './assets/club-shields/BRE.svg'
import brighton from './assets/club-shields/BHA.svg'
import chelsea from './assets/club-shields/CHE.svg'
import coventryCity from './assets/club-shields/COV.svg'
import crystalPalace from './assets/club-shields/CRY.svg'
import everton from './assets/club-shields/EVE.svg'
import fulham from './assets/club-shields/FUL.svg'
import hull from './assets/club-shields/HUL.svg'
import ipswichTown from './assets/club-shields/IPS.svg'
import leeds from './assets/club-shields/LEE.svg'
import leicesterCity from './assets/club-shields/LEI.svg'
import liverpool from './assets/club-shields/LIV.svg'
import manchesterCity from './assets/club-shields/MCI.svg'
import manchesterUnited from './assets/club-shields/MUN.svg'
import newcastleUnited from './assets/club-shields/NEW.svg'
import nottinghamForest from './assets/club-shields/NFO.svg'
import sunderland from './assets/club-shields/SUN.svg'
import tottenhamHotspurs from './assets/club-shields/TOT.svg'
import westHamUnited from './assets/club-shields/WHU.svg'
import { findTeamId, teamAbbr, type TeamId } from './teams'

/**
 * Keyed on the three-letter abbreviation, which is what the shield files are named — so this map
 * has exactly one row per club and no spelling variants at all.
 *
 * The alias block that used to live here carried both 'Ipswich' and
 * 'Ipswich Town', both 'Man Utd' and 'Man United', and so on, duplicated again in
 * `clubAbbreviations` below it. Both are now single lookups against the team registry.
 */
const shieldsByAbbr: Record<string, string> = {
  ARS: arsenal,
  AVL: astonVilla,
  BHA: brighton,
  BOU: bournemouth,
  BRE: brentford,
  CHE: chelsea,
  COV: coventryCity,
  CRY: crystalPalace,
  EVE: everton,
  FUL: fulham,
  HUL: hull,
  IPS: ipswichTown,
  LEE: leeds,
  LEI: leicesterCity,
  LIV: liverpool,
  MCI: manchesterCity,
  MUN: manchesterUnited,
  NEW: newcastleUnited,
  NFO: nottinghamForest,
  SUN: sunderland,
  TOT: tottenhamHotspurs,
  WHU: westHamUnited,
}

/**
 * The club's shield, or undefined for anything the registry doesn't know. Accepts a team id
 * (the normal case) or any historic spelling, since a few mock/profile payloads still carry names.
 */
export function getClubBanner(team: TeamId | string | null | undefined): string | undefined {
  const id = findTeamId(team)
  if (id === null) return undefined
  return shieldsByAbbr[teamAbbr(id)]
}

/** The club's canonical three-letter code. */
export function getClubAbbr(team: TeamId | string | null | undefined): string {
  const id = findTeamId(team)
  if (id !== null) return teamAbbr(id)
  // Unknown clubs shouldn't reach the UI; a three-letter slice beats rendering nothing.
  return String(team ?? '').slice(0, 3).toUpperCase()
}
